import { render, staticRenderFns } from "./Ostatni.vue?vue&type=template&id=62ba88ff&"
import script from "./Ostatni.vue?vue&type=script&lang=ts&"
export * from "./Ostatni.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports